import React, { useState } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { padding } from '@mui/system';
import Grid from '@mui/material/Grid';
import logo from './assets/img/TABNavLogo.webp'


function StarMenuBar({ title }) {
  const [stepTitle, setStepTitle] = useState(title);
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4} style={{textAlign: "left"}}>
              <Typography variant="h6" component="div">
                <img style={{ padding: '10px 20px', marginTop: "5px" }} src={logo} />
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}></Grid>
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4} sx={{ margin: 'auto' }}>
              <Typography sx={{ fontSize: '16px', padding: '12px', color: "#202122",  }} component="div">
                To report accessibility issues or submit questions, please call us at <a style={{color:"#007fb0"}} href='tel:800-355-3063'>800-355-3063</a> or email us at <a style={{color:"#007fb0"}} href='mailto:yellowteam.sme@tabbank.com'>yellowteam.sme@tabbank.com</a>.
              </Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

export default StarMenuBar